<template>
  <div id="reporting-wrapper">
    <h1>Reports</h1>
    <div class="col-md-12">
      <ul class="nav nav-tabs">
        <li class="nav-item" v-for="tab in tabs" :key="tab.id" @click="selected = tab.name">
          <router-link
            :class="{'nav-link': isNavLink, 'active': tab.name === selected}"
            :to="tab.route"
          >{{tab.name}}</router-link>
        </li>
      </ul>
      <router-view/>
    </div>
  </div>
</template>
<script>
export default {
  data () {
    return {
      isNavLink: true,
      selected: 'Offers',
      tabs: [
        { name: 'Offers', route: 'offers' },
        { name: 'Sets', route: 'sets' },
        { name: 'Progression', route: 'progression' }
      ]
    }
  },
  mounted () {
  },
  methods: {
  },
  computed: {}
}

</script>
<style lang="scss" scoped>
#reporting-wrapper {
  .nav-tabs {
    border-bottom: none;
  }
  .active {
    border-radius: 6px 6px 0px 0px;
    border-color: $white;
    background-color: $white;
  }
  margin: 0px;
}
</style>
